import { createAction } from '@reduxjs/toolkit';
import Services from 'services/network';
import { actionTypes } from 'modules/booking/constants';
import { enqueueErrorNotification } from 'common/state/notifications/actions';
import { GeneralThunkAction } from 'common/state/interfaces';
import { INamedEntity } from 'common/interfaces/common';

const fetchEventServicesLoading = createAction<boolean>(actionTypes.FETCH_EVENT_SERVICES_LOADING);
const fetchEventServices = createAction<INamedEntity[]>(actionTypes.FETCH_EVENT_SERVICES);
export const resetEventServices = createAction<INamedEntity[] | undefined>(
  actionTypes.RESET_EVENT_SERVICES,
);

export const fetchEventServicesThunk = (search: string): GeneralThunkAction => {
  return async dispatch => {
    dispatch(fetchEventServicesLoading(true));

    try {
      const services = await Services.Booking.getEventServices(search);

      dispatch(fetchEventServices(services));
    } catch (error) {
      dispatch(enqueueErrorNotification(error));
    } finally {
      dispatch(fetchEventServicesLoading(false));
    }
  };
};
